module.exports = __webpack_public_path__ + "assets/img/phone_icon.4df7faf5.png";